import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { PainPointsSection } from './components/PainPointsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TransformationSection } from './components/TransformationSection';
import { KitContentsSection } from './components/KitContentsSection';
import { PreviewSection } from './components/PreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
import { MetaPixel } from './components/MetaPixel';
import { HERO_MOCKUP, SITE_DESCRIPTION, SITE_TITLE, SITE_URL } from './data/site';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'fr';
    document.title = SITE_TITLE;
    setMeta('name', 'description', SITE_DESCRIPTION);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', 'fr_FR');
    setMeta('property', 'og:site_name', 'MUSIQUE PRÊTE');
    setMeta('property', 'og:title', SITE_TITLE);
    setMeta('property', 'og:description', SITE_DESCRIPTION);
    setMeta('property', 'og:url', SITE_URL);
    setMeta('property', 'og:image', HERO_MOCKUP.src);
    setMeta('property', 'og:image:width', String(HERO_MOCKUP.width));
    setMeta('property', 'og:image:height', String(HERO_MOCKUP.height));
    setMeta('property', 'og:image:alt', HERO_MOCKUP.alt);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SITE_TITLE);
    setMeta('name', 'twitter:description', SITE_DESCRIPTION);
    setMeta('name', 'twitter:image', HERO_MOCKUP.src);
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL;
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3bmbehq4nwbke">
      <div className="min-h-screen w-full bg-white font-sans text-slate-800 selection:bg-brand-gold/40" data-id="element-1" data-mp="3bncnzq614q00">
        <MetaPixel data-id="element-2" data-mp="3qbzg6sgr9c8n" />
        <AnnouncementBar data-id="element-3" data-mp="3qcim1at4sa6b" />
        <main data-id="element-4" data-mp="3lkheu3atl9n5">
          <HeroSection data-id="element-5" data-mp="3lkr2vlcb16q7" />
          <StatsBar data-id="element-6" data-mp="3ljg11r2f691q" />
          <PainPointsSection data-id="element-7" data-mp="3liwm8j82g0rx" />
          <ComparisonSection data-id="element-8" data-mp="3limuor7dhlk4" />
          <TransformationSection data-id="element-9" data-mp="2xu3k250uowov" />
          <KitContentsSection data-id="element-10" data-mp="2xtbzrqcpeldw" />
          <PreviewSection data-id="element-11" data-mp="2svtnpr3e3q1o" />
          <InstantAccessSection data-id="element-12" data-mp="2swbq75gnb0i1" />
          <ForWhoSection data-id="element-13" data-mp="2svafj23jkg0u" />
          <BonusesSection data-id="element-14" data-mp="2stzcx5lu1ebb" />
          <PricingSection data-id="element-15" data-mp="18d9e69sxtqtr" />
          <GuaranteeSection data-id="element-16" data-mp="18czm8goc19lf" />
          <FAQSection data-id="element-17" data-mp="18boj8j2po5vd" />
          <FinalCTASection data-id="element-18" data-mp="1d4hod823dg7z" />
        </main>
        <Footer data-id="element-19" data-mp="1d59kcjzlpfys" />
        <StickyCTABar data-id="element-20" data-mp="1d62l94bvpb90" />
      </div>
    </MotionConfig>;
}
function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}